import {useState, useEffect, useRef} from "react";
import {isDesktop} from "@/Helpers/Function";

const useScrollDirection = (enabled = true) => {
    const [scrollDirection, setScrollDirection] = useState("up");
    const lastScrollY = useRef(0);
    const ticking = useRef(false);
    const threshold = 5; // Минимальное значение изменения скролла, чтобы избежать ложных срабатываний

    useEffect(() => {
        if (!enabled || isDesktop()) return;

        const handleScroll = () => {
            const currentScrollY = Math.max(window.scrollY, 0);

            if (!ticking.current) {
                window.requestAnimationFrame(() => {
                    if (Math.abs(currentScrollY - lastScrollY.current) > threshold) {
                        setScrollDirection(
                            currentScrollY > lastScrollY.current ? "down" : "up"
                        );
                        lastScrollY.current = currentScrollY;
                    }
                    ticking.current = false;
                });

                ticking.current = true;
            }
        };

        window.addEventListener("scroll", handleScroll, {passive: true});

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [enabled]);

    return enabled ? scrollDirection : null;
};

// const useScrollDirectionOld = () => {
//     const [scrollDirection, setScrollDirection] = useState("up");
//     const [lastScrollY, setLastScrollY] = useState(0);
//     const [ticking, setTicking] = useState(false);
//     const threshold = 5; // Минимальное значение изменения скролла, чтобы избежать ложных срабатываний
//
//     useEffect(() => {
//         const handleScroll = () => {
//             const currentScrollY = Math.max(window.scrollY, 0);
//
//             if (!ticking) {
//                 window.requestAnimationFrame(() => {
//                     if (Math.abs(currentScrollY - lastScrollY) > threshold) {
//                         setScrollDirection(currentScrollY > lastScrollY ? "down" : "up");
//                         setLastScrollY(currentScrollY);
//                     }
//                     setTicking(false);
//                 });
//                 setTicking(true);
//             }
//         };
//
//         window.addEventListener("scroll", handleScroll, {passive: true});
//
//         return () => {
//             window.removeEventListener("scroll", handleScroll);
//         };
//     }, [lastScrollY, ticking]);
//
//     return scrollDirection;
// };

export default useScrollDirection;
